import { getProductsAsObject, productSettingsExists } from './productsHelpers';
import { gatherProductMeasurement } from '../../services/products/productMeasurementsGatherer';
import { GetState, Itemids, ThunkDispatch } from '../../generalTypes';

export const formatProductsMeasurements =
  (products: Itemids) => (dispatch: ThunkDispatch, getState: GetState) => {
    const prods = getProductsAsObject();

    return products.reduce((acc: any, curr: Itemids | any) => {
      if (!curr.length) return acc;

      const product = prods[curr[0]];
      if (!productSettingsExists(product)) return acc;

      return [...acc, gatherProductMeasurement(curr, getState())];
    }, []);
  };
